// @flow
import React, { useState, useEffect } from "react";
import { TableFilterRow } from "@devexpress/dx-react-grid-material-ui";
import TableCell from "@material-ui/core/TableCell";
import { all, spread } from "axios";

import api from "api";
import * as resources from "resources";
import type { CellProps } from "../types";
import SelectFilterCell from "./SelectFilterCell";

function FilterCellComponent(cell: CellProps) {
  const [teamStatusOptions, setTeamStatusOptions] = useState([]);
  const [eligibilityOptions, setEligbilityOptions] = useState([]);
  const [titleOptions, setTitleOptions] = useState([]);
  const [shirtSizeOptions, setShirtSizeOptions] = useState([]);
  const [includeEmailOptions, setIncludeEmailOptions] = useState([]);
  const [sexOptions, setSexOptions] = useState([]);
  const [informOtherContestsOptions, setInformOtherContestsOptions] = useState(
    []
  );
  const [employmentOpportunitiesOptions, setEmploymentOpportunitiesOptions] =
    useState([]);
  // top 20
  const [teamRoleOptions, setTeamRoleOptions] = useState([]);
  const [institutionUnitType, setInstitutionUnitType] = useState([]);

  useEffect(() => {
    all([
      api.get(resources.FormStructure.TEAM),
      api.get(resources.FormStructure.ELIGIBILITY),
      api.get(resources.FormStructure.PERSON_MAIN_INFO),
      api.get(resources.FormStructure.TEAM_MEMBER),
      api.get(resources.FormStructure.INSTITUTION_UNIT),
    ]).then(
      spread(
        (team, eligibility, personMainInfo, teamMember, institutionUnit) => {
          const _teamStatusOptions = team.data.fields[0].options.map(
            (option) => ({ value: option[0], label: option[1] })
          );
          setTeamStatusOptions(_teamStatusOptions);

          const _eligibilityOptions = eligibility.data.fields[0].options.map(
            (option) => ({ value: option[0], label: option[1] })
          );
          setEligbilityOptions(_eligibilityOptions);

          const _titleOptions =
            personMainInfo.data.obj[0].fields[0].options.map((option) => ({
              value: option[0],
              label: option[1],
            }));
          setTitleOptions(_titleOptions);

          const _shirtSizeOptions =
            personMainInfo.data.obj[0].fields[7].options.map((option) => ({
              value: option[0],
              label: option[1],
            }));
          setShirtSizeOptions(_shirtSizeOptions);

          const _includeEmailOptions =
            personMainInfo.data.obj[0].fields[20].options.map((option) => ({
              value: option[0],
              label: option[1],
            }));
          setIncludeEmailOptions(_includeEmailOptions);

          const _sexOptions = personMainInfo.data.obj[0].fields[6].options.map(
            (option) => ({ value: option[0], label: option[1] })
          );
          setSexOptions(_sexOptions);

          const _informOtherContestsOptions =
            personMainInfo.data.obj[0].fields[19].options.map((option) => ({
              value: option[0],
              label: option[1],
            }));
          setInformOtherContestsOptions(_informOtherContestsOptions);

          const _employmentOpportunitiesOptions =
            personMainInfo.data.obj[0].fields[22].options.map((option) => ({
              value: option[0],
              label: option[1],
            }));
          setEmploymentOpportunitiesOptions(_employmentOpportunitiesOptions);

          // top 20
          const _teamRoleOptions = teamMember.data.fields[0].options.map(
            (option) => ({ value: option[0], label: option[1] })
          );
          setTeamRoleOptions(_teamRoleOptions);

          const _institutionUnitType =
            institutionUnit.data.fields[5].options.map((option) => ({
              value: option[0],
              label: option[1],
            }));
          setInstitutionUnitType(_institutionUnitType);
        }
      )
    );
  }, []);

  const booleanColumns = [
    "paid",
    "registrationComplete",
    "completeRegistration",
    "certified",
    "published",
  ];

  const cellProps = {
    "data-test": `filter-input-${cell.column.name}`.toLowerCase(),
    ...cell,
  };

  if (!cell.column.filterable) {
    // if this cell is not filterable, return empty cell
    return <TableCell />;
  } else if (cell.column.name === "eligibilityStatus") {
    return (
      <SelectFilterCell {...cellProps} selectOptions={eligibilityOptions} />
    );
  } else if (cell.column.name === "informOtherContests") {
    return (
      <SelectFilterCell
        {...cellProps}
        selectOptions={informOtherContestsOptions}
      />
    );
  } else if (cell.column.name === "employmentOpportunities") {
    return (
      <SelectFilterCell
        {...cellProps}
        selectOptions={employmentOpportunitiesOptions}
      />
    );
  } else if (["status", "teamStatus"].includes(cell.column.name)) {
    return (
      <SelectFilterCell {...cellProps} selectOptions={teamStatusOptions} />
    );
  } else if (booleanColumns.includes(cell.column.name)) {
    const booleanOptions = [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" },
    ];
    return <SelectFilterCell {...cellProps} selectOptions={booleanOptions} />;
  } else if (cell.column.name === "specialNeeds") {
    const options = [
      { value: "", label: "Any" },
      { value: "true", label: "Yes" },
    ];
    return <SelectFilterCell {...cellProps} selectOptions={options} />;
  } else if (cell.column.name === "terminalType") {
    const options = [
      { value: "FLIGHT", label: "FLIGHT" },
      { value: "TRAIN", label: "TRAIN" },
      { value: "NONE", label: "NONE" },
    ];
    return <SelectFilterCell {...cellProps} selectOptions={options} />;
  } else if (cell.column.name === "title") {
    return <SelectFilterCell {...cellProps} selectOptions={titleOptions} />;
  } else if (cell.column.name === "shirtSize") {
    return <SelectFilterCell {...cellProps} selectOptions={shirtSizeOptions} />;
  } else if (cell.column.name === "includeEmail") {
    return (
      <SelectFilterCell {...cellProps} selectOptions={includeEmailOptions} />
    );
  } else if (cell.column.name === "sex") {
    return <SelectFilterCell {...cellProps} selectOptions={sexOptions} />;
  }
  // top 20
  // else if (cell.column.name === "role") {
  //   return <SelectFilterCell {...cell} selectOptions={teamRoleOptions} />;
  // }
  else if (cell.column.name === "inform") {
    return (
      <SelectFilterCell
        {...cellProps}
        selectOptions={informOtherContestsOptions}
      />
    );
  } else if (cell.column.name === "type") {
    return (
      <SelectFilterCell {...cellProps} selectOptions={institutionUnitType} />
    );
  } else if (cell !== undefined) {
    return <TableFilterRow.Cell {...cellProps} />;
  }
}

export default FilterCellComponent;
